import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const STAGE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Stage.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const STAGE_CONFIG = {
  entityName: 'Stage',
  localizationKey: 'Controlling::Entity.Stage',
  fields: STAGE_FIELDS,
  permission: 'ControllingActivities.Stages',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
